import React, { useState, useEffect } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import ButtonComponent from 'react-button-component';
import LoadingOverlay from 'react-loading-overlay';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
const useStyles = makeStyles((theme) => ({
	btnSearch: {
        marginTop: 30,
        backgroundColor: "green",
	},
    modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
    modal2: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "400px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
    field:{
        width: "90%"
    },
    autoComplete:{
        width: "90%"
    },
    modalBtn:{
        display:"flex-end"
    },
    dangerBtn:{
        backgroundColor:"red",
        color:"white"
    },
    floatRight: {
        margin: theme.spacing(1),
    }
}));
const PackageSalesNavSettingsFranchise = (props) => {
    const navid = props.location.franchisedetails ? props.location.franchisedetails.navid : '';
    const navname = props.location.franchisedetails ? props.location.franchisedetails.navname : '';
  

    const classes = useStyles();
    const [nextPagePath, setNextPagePath] = useState("");
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [isLoaded, setisLoaded] = useState();
    const [selectedpackagetype, setSelectedPackageType] = useState("");
    const [selectedRecord, setSelectedRecord] = useState({});
    const [record_data, setRecordData] = useState({});
    const [saveState, setSaveState] = useState(false);
    const [dropdownCurrency, setDropDownCurrency] = useState([]);
    //checkboxes state
    const [cb1, checkCB1] = useState(false);
    const [cb2, checkCB2] = useState(false);
    const [cb3, checkCB3] = useState(false);
    const [cb4, checkCB4] = useState(false);
    const [cb5, checkCB5] = useState(false);

	const nextpage =  {
		// pathname: "/package-sales-payment",
		pathname: nextPagePath,
	}
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
	//ApiData Component useState SOF
    const packagesalesnavsummary = () => {
        setisLoaded(false);
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
            navid: navid
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'packagesalesfranchisedetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            loadNavDetails(res.data);
		});
	};
    const get_currency_list = () => {
        const formData = new FormData();
        formData.append('form_data', "");
        const apiUrl = process.env.REACT_APP_API_URL+'getallcurrency';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			setDropDownCurrency(res.data.currency_list);
		});
	};
    const updaterecord = () => {
        //get data for warehouse/location dropdown
		const form_data = {
			id: selectedRecord.id,
            record_data: record_data
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'updatepackagesalesfranchisedetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
                packagesalesnavsummary();
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
            }
		});
	};
    const saverecord = () => {
        //get data for warehouse/location dropdown
		const form_data = {
            record_data: record_data,
            navid:navid
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'savepackagesalesfranchisedetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                    packagesalesnavsummary();
                }, 3000)
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
            }
		});
	};

    const deleterecord = () => {
        handleClose2();
        //get data for warehouse/location dropdown
		const form_data = {
            id: selectedRecord.id
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'deletepackagesalesfranchisedetails';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
                packagesalesnavsummary();
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                    setShowOverlay(false);
                    setOverlayMsg('');
                }, 3000)
            }
		});
	};

    const validate_required = () => {
		const apiUrl = process.env.REACT_APP_API_URL+'validate_required';
        let form_data = {};
            if(navid == "28" || navid == "29" || navid == "30" || navid == "31")
            {
                form_data = {
                    required_fields: required_fields_other,
                    reqfield_obj: record_data,
                }
            }else{
                form_data = {
                    required_fields: required_fields,
                    reqfield_obj: record_data,
                }
            }

        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
			if(res.data.result.success == 1){
				if(saveState == true){
                    saverecord();
                }else{
                    updaterecord();
                }
                handleClose();
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);
	const loadNavDetails = (data) => {
        refreshTable();
		const newData = [...TABLE_DATA];
		for (let i=0;i < data.franchisedetailssummary.length;i++) {
            const tempObj = {id:data.franchisedetailssummary[i][0], curcode:data.franchisedetailssummary[i][1], price:data.franchisedetailssummary[i][2],finders_fee:data.franchisedetailssummary[i][3],finders_fee_promo:data.franchisedetailssummary[i][4],products:data.franchisedetailssummary[i][5],marketing:data.franchisedetailssummary[i][6],
                action:<Grid container spacing={1}>
                <Grid item xs={12} lg={12} xl={5}>
                                <Button variant="contained" color="primary"  onClick={(e) => {viewdetails(data.rawfranchisedetailssummary[i])}}>Edit</Button>
                                </Grid>
                                <Grid item xs={12} lg={12} xl={5}>
                                <Button variant="contained" className={[classes.dangerBtn]}  onClick={(e) => {process_delete(data.rawfranchisedetailssummary[i])}}>Delete</Button>
                            </Grid>
                        </Grid>
                }
            newData.push(tempObj);
        }
		loadDataTable([...newData]);
        setisLoaded(true);
	};
    
	const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}

    const viewfranchisedetails = () => {
	}

	const TABLE_COLUMNS = [
		{
		  name: 'id',
		  label: 'ID',
		}, {
		  name: 'curcode',
		  label: 'Currency',
		},  {
            name: 'price',
            label: 'Package Amount',
            options: {
                setCellProps: () => ({ style: { textAlign: "right"}}),
          },
        },
        {
            name: 'products',
            label: 'Products (Srp)',
            options: {
                setCellProps: () => ({ style: { textAlign: "right"}}),
          },
        },
        {
            name: 'marketing',
            label: 'Marketing',
            options: {
                setCellProps: () => ({ style: { textAlign: "right"}}),
          },
        },
        {
            name: 'finders_fee_promo',
            label: 'Finders Fee Promo',
            options: {
                setCellProps: () => ({ style: { textAlign: "right"}}),
          },
        },
        {
            name: 'finders_fee',
            label: 'Finders Fee',
            options: {
                setCellProps: () => ({ style: { textAlign: "right"}}),
          },
        }, {
            name: 'action',
            label: 'Action',
            options: {
                setCellProps: () => ({ style: { minWidth: "100px", maxWidth: "100px" }}),
                customBodyRender: (data, type, row) => {return <pre>{data}</pre>}
          },
        }
	];
	
	const TABLE_OPTION = {
        selectableRows: 'none'
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
    const handleOpen2 = () => {
		setOpen2(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
    const handleClose2 = () => {
		setOpen2(false);
	};
	//Modal Settings EOF
    const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}

    const viewdetails = (navdetails) => {
        setSelectedRecord(navdetails);
        handleOpen();
        onRecordOpen();
        setSaveState(false);
    }

    const new_record = () => {
        setSaveState(true);
        setRecordData("");
        handleOpen();
        const newData = {...record_data};
		newData['package_price_franchise']= 0;
        newData['paid_accounts']= 0;
        newData['food_cart']= 0;
        newData['products']= 0;
        newData['marketing']= 0;
        newData['finders_fee']= 0;
        newData['finders_fee_promo']= 0;
        newData['curcode']= 'PHP';
        newData['franchise_status']= 1;
		setRecordData({ ...newData });
    }
    useEffect(() => {
        onRecordOpen();
    }, [selectedRecord]);
    //FormData
	const [prep_data, setData] = useState({"startDate":formatDate(new Date()),"endDate":formatDate(new Date())});
	//FormData EOF
	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        get_currency_list();
        packagesalesnavsummary();
    }, []);
    //OnLoad Event/Data Fetching SOF

	const onInputChange = (event) => {
		const newData = {...prep_data};
		newData[event.target.name]= event.target.value;
		setData({ ...newData });
	}

    const onRecordChange = (event) => {
		const newData = {...record_data};
		newData[event.target.name]= event.target.value;
		setRecordData({ ...newData });
	}
    const onRecordChangeCB = (event) => {
        if (event.target.checked == true) {
            check_checkbox(event.target.name);
        } else {
            uncheck_checkbox(event.target.name);
        }
    }
    const check_checkbox = (checkboxname) => {
        const newData = {...record_data};
        if(checkboxname == "itemselection"){
            checkCB1(true);
            newData['itemselection']= "yes";
        }
        if(checkboxname == "discounteditems"){
            checkCB2(true);
            newData['discounteditems']= "yes";
        }
        if(checkboxname == "isfranchise"){
            checkCB3(true);
            newData['isfranchise']= 1;
        }
        if(checkboxname == "isidnoincentive"){
            checkCB4(true);
            newData['isidnoincentive']= 1;
        }
        if(checkboxname == "isidnoincentivemc"){
            checkCB5(true);
            newData['isidnoincentivemc']= 1;
        }
        setRecordData({ ...newData });
    }
    const uncheck_checkbox = (checkboxname) => {
        const newData = {...record_data};
        if(checkboxname == "itemselection"){
            checkCB1(false);
            newData['itemselection']= "no";
        }
        if(checkboxname == "discounteditems"){
            checkCB2(false);
            newData['discounteditems']= "no";
        }
        if(checkboxname == "isfranchise"){
            checkCB3(false);
            newData['isfranchise']= 0;
        }
        if(checkboxname == "isidnoincentive"){
            checkCB4(false);
            newData['isidnoincentive']= 0;
        }
        if(checkboxname == "isidnoincentivemc"){
            checkCB5(false);
            newData['isidnoincentivemc']= 0;
        }
        setRecordData({ ...newData });
    }
    
    const onRecordOpen = () => {
		const newData = {...record_data};
		newData['package_price_franchise']= selectedRecord.package_price_franchise;
        newData['paid_accounts']= selectedRecord.paid_accounts;
        newData['food_cart']= selectedRecord.food_cart;
        newData['products']= selectedRecord.products;
        newData['marketing']= selectedRecord.marketing;
        newData['finders_fee']= selectedRecord.finders_fee;
        newData['finders_fee_promo']= selectedRecord.finders_fee_promo;
        newData['curcode']= selectedRecord.curcode;
        newData['franchise_status']= selectedRecord.franchise_status;
		setRecordData({ ...newData });
	}

    const process_delete = (navdetails) => {
        handleOpen2();
        setSelectedRecord(navdetails);
    }

    const required_fields = [
		"package_price_franchise",
		"paid_accounts",
		"products",
		"curcode",
		"franchise_status"
	];

    const required_fields_other = [
		"package_price_franchise",
		"paid_accounts",
		"curcode",
		"franchise_status"
	];

    //Date Picker EOF
	return (
        !navid ? <Redirect to="/package-sales" /> :
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/settings">
						<h2 className="header-title">Settings</h2>
					</NavLink>
                    <NavLink to="/packagesalesnav-settings">
						<h2 className="header-title">Package Sales Navigation Settings</h2>
					</NavLink>
					<Typography color="textPrimary">Package Sales Navigation Settings Franchise Details</Typography>
				</Breadcrumbs>
			</div>
            <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-container">
                <Grid container spacing={2} alignItems="center" justify="center" className={classes.root}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <h2 className={classes.title}>{navname}</h2>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Button 
                            variant="contained" 
                            color="primary"
                            className={classes.btnSearch}
                            style={{float:"right"}}
                            onClick={(e) => {
                                new_record();
                            }}>
                            Add
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{marginTop:"10px"}}>
                { 
                    !isLoaded ?  <Preloader /> :										
                    <MUIDataTable
                        title={
                            <div>
                                <div className="table-title">
                                    Package Sales Franchise Details
                                </div>
                            </div>
                        }
                        id="table-grid"
                        data={TABLE_DATA}
                        columns={TABLE_COLUMNS}
                        options={TABLE_OPTION}
                    />
                }
                </Grid>
			</div>
            </LoadingOverlay>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h2 id="transition-modal-title">Franchise Details</h2>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="package_price_franchise"
                                            label="Package Price"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.package_price_franchise}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="paid_accounts"
                                            label="Paid Accounts"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.paid_accounts}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="food_cart"
                                            label="Food Cart"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            value={record_data.food_cart}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <Autocomplete
                                            options={dropdownCurrency}
                                            autoComplete
                                            includeInputInList
                                            value={record_data.curcode}
                                            className={classes.autoComplete}
                                            name="curcode"
                                            required="true"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="normal"
                                                    label="Currency"	
                                                    variant="outlined"
                                                    required="true"
                                                />
                                            )}
                                            onChange={(event, newValue) => {
                                                if (!newValue == "" || !newValue == null){
                                                    const newData = {...record_data};
                                                    newData['curcode']= newValue;
                                                    setRecordData({ ...newData });
                                                }
                                            }}
                                        />
                                    </Grid>  
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="products"
                                            label="Products"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.products}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="marketing"
                                            label="Marketing"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            value={record_data.marketing}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>  
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="finders_fee"
                                            label="Finders Fee"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"  
                                            value={record_data.finders_fee}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="finders_fee_promo"
                                            label="Finders Fee Promo"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            value={record_data.finders_fee_promo}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={3}>
                                    <Grid xs={12} sm={6}>
                                        <TextField
                                            name="franchise_status"
                                            label="Franchise Status"
                                            variant="outlined"
                                            type="text"
                                            margin="normal"
                                            required="true"
                                            value={record_data.franchise_status}
                                            className={classes.field}
                                            onChange={onRecordChange}
                                        />
                                    </Grid>
                                </Grid>
                                <div className={classes.button} style={{float:"right"}}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            onClick={validate_required}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal2}
                    open={open2}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open2}>
                        <div className={classes.paper}>
                            <h2 id="transition-modal-title">System Message</h2>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <h4>Are you sure you want to delete this currency</h4>
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <div  className={classes.floatRight}></div>
                                    <Grid item xs={3}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose2}
                                            className={classes.buttonMarginRight}
                                            style={{backgroundColor:"red",color:"white",float:'right'}}
                                        >
                                            No
                                        </Button>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Button
                                            variant="contained"
                                            onClick={deleterecord}
                                        >
                                            Yes
                                        </Button>
                                    </Grid>
                                </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
		</div>
	);
};

export default PackageSalesNavSettingsFranchise;
